import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "error-warning-update" }
const _hoisted_2 = {
  id: "detailList",
  class: ""
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, " Agency Name: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, " Agency Ori: ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, " Error/Warning description: ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dt", null, " Status: ", -1)
const _hoisted_7 = { class: "form-check" }
const _hoisted_8 = ["name", "id", "value"]
const _hoisted_9 = ["for"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, " Explanation/Justification: ", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createTextVNode(" Action date: "),
  /*#__PURE__*/_createElementVNode("label", { id: "ActiondateValue" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("dt", null, " Actioned by: ", -1)
const _hoisted_15 = { class: "hstack gap-2" }

import { computed, ref, watch, onMounted } from 'vue';
import axios from 'axios';
//props and variables

export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorsAndWarningsUpdate',
  props: {
    item: {},
    url: {},
    dataset: {},
    uploadHeaders: { default: {} }
  },
  emits: ["dismiss"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const statusList = [
    { id: "unresolved", text: "Unresolved", value: "0" },
    { id: "dismissed", text: "Dismissed/Cleared", value: "1" }
];
var statusValue = ref("");
var explanationValue = ref("");
var dataItem = ref({} as any);


//computed properties
const incidentNumberLabel = computed(() => {

    if (props.dataset?.toLocaleLowerCase() == 'communityPolicing') {
        return "Stop Number";
    }

    return "Incident Number";
});
const typeAndCode = computed(() => {
    return `${dataItem.value["errorType"]} ${dataItem.value["errorCode"]}`
});
const errorDesc = computed(() => {
    return dataItem.value["description"];
});
const idValue = computed(() => {
    return props.dataset == 'communityPolicing' ? dataItem.value["stopNumber"] : dataItem.value['incidentNumber'];
});

//methods section
function handleConfirmClick() {
    if (statusValue.value != null && explanationValue.value != null && statusValue.value.length > 0 && explanationValue.value.length > 0) {

        let dataToPost = {
            id: dataItem.value.id,
            status: statusValue.value,
            explanation: explanationValue.value,
            code: dataItem.value["errorCode"]
        }

        axios.post(props.url, dataToPost, {
            headers: props.uploadHeaders,
        }).catch((err) => {
            let message = typeof err.response !== "undefined" ? err.response.data.message : err.message;
            console.warn("error", message);
        }).finally(() => {
            handleDismissClick();
        });
    }
}
function handleDismissClick() {
    emit('dismiss');
}

function getData() {  

    if (props.item != null) {
        dataItem.value = props.item;
    }
}

function getRequiredCssClass(baseCssClasses, isValid) {

    if (isValid) {
        return baseCssClasses;
    }

    return baseCssClasses + " is-invalid";
}

watch(
    () => props.item,
    (item, prevItem) => {
        if (item != null) {
            dataItem.value = item;

            if (dataItem.value["isAcknowledged"]) {
                statusValue.value = "1";
            }
            else {
                statusValue.value = "0";
            }

            explanationValue.value = dataItem.value["explanation"];
        }
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dl", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("dd", null, _toDisplayString(_unref(dataItem).agency), 1),
      _hoisted_4,
      _createElementVNode("dd", null, _toDisplayString(_unref(dataItem).ori), 1),
      _createElementVNode("dt", null, _toDisplayString(incidentNumberLabel.value) + ": ", 1),
      _createElementVNode("dd", null, _toDisplayString(idValue.value), 1),
      _hoisted_5,
      _createElementVNode("dd", null, [
        _createElementVNode("span", null, _toDisplayString(typeAndCode.value), 1),
        _createTextVNode(" - " + _toDisplayString(errorDesc.value), 1)
      ]),
      _hoisted_6,
      _createElementVNode("dd", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusList, (status) => {
          return _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "radio",
              name: status.id,
              id: status.id,
              value: status.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(statusValue) ? (statusValue).value = $event : statusValue = $event)),
              required: ""
            }, null, 8, _hoisted_8), [
              [_vModelRadio, _unref(statusValue)]
            ]),
            _createElementVNode("label", {
              class: "form-check-label",
              for: status.id
            }, _toDisplayString(status.text), 9, _hoisted_9)
          ])
        }), 64))
      ])
    ]),
    (_unref(statusValue) == '1')
      ? (_openBlock(), _createElementBlock("dl", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("dd", null, [
            _withDirectives(_createElementVNode("textarea", {
              class: _normalizeClass(getRequiredCssClass('form-control', _unref(explanationValue) != null && _unref(explanationValue).length > 0)),
              rows: "5",
              style: {"width":"80%"},
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(explanationValue) ? (explanationValue).value = $event : explanationValue = $event)),
              required: ""
            }, null, 2), [
              [_vModelText, _unref(explanationValue)]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(dataItem)['isAcknowledged'] && _unref(statusValue) == '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("dl", null, [
            _hoisted_13,
            _createElementVNode("dd", null, _toDisplayString(_unref(dataItem)['acknowledgedOn']), 1),
            _hoisted_14,
            _createElementVNode("dd", null, _toDisplayString(_unref(dataItem)['acknowledgedBy']), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleConfirmClick()), ["prevent"]))
      }, "Update"),
      _createElementVNode("button", {
        class: "btn btn-danger",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleDismissClick()), ["prevent"]))
      }, "Cancel")
    ])
  ]))
}
}

})